<div class="container-fluid p-4">
  <h3>Finance Account List</h3>
  <div class="d-flex gap-3 my-3 justify-content-between">
    <mat-form-field subscriptSizing="dynamic" style="width: 450px">
      <mat-label>Search</mat-label>
      <input matInput type="text" placeholder="Search" [ngModel]="searchText()" (ngModelChange)="searchText.set($event)" />
      @if (searchText()) {
        <button matSuffix mat-icon-button aria-label="Clear" (click)="searchText.set('')">⨉</button>
      }
    </mat-form-field>
  @if (sharedService.isRoles([enums.BOSS, enums.FINANCE])) {
    <button class="btn btn-primary" (click)="openAddFAModal()"><i class="fas fa-plus"></i> Finance Account</button>
  }
  </div>

  <div class="d-flex gap-2 align-items-center">
    <div>Quick Filter:</div>
    <mat-chip-listbox class="gap-2 mb-1" multiple>
      <mat-chip-option [selected]="showActive()" (click)="showActive.set(!showActive())">Active</mat-chip-option>
      <mat-chip-option [selected]="showDisabled()" (click)="showDisabled.set(!showDisabled())">Disabled</mat-chip-option>
    </mat-chip-listbox>
  </div>
  <div class="shadow">
    <table mat-table [dataSource]="table.dataSource()" (matSortChange)="table.sortState.set($event)" matSort>
      <ng-container matColumnDef="Action">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Action</th>
        <td mat-cell *matCellDef="let fa; let i = index">
        @if (fa.Disabled == false) {
          <button class="btn" (click)="updateFinanceAccount(fa)" title="Edit"><i class="fas fa-pencil-alt text-secondary"></i></button>
          <button class="btn" (click)="disableFinanceAccount(fa, i)" title="Disable"><i class="fas fa-times text-secondary"></i></button>
        }
        </td>
      </ng-container>
    @for (c of table.config(); track c.columnDef) {
      <ng-container [matColumnDef]="c.columnDef">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ c.header }}</th>
        <td mat-cell *matCellDef="let row">
        @if (c.onClick) {
          <div (click)="c.onClick(row)" class="pointer">{{ table.formatValue(row, c) }}</div>
        } @else {
          {{ table.formatValue(row, c) }}
        }
        </td>
      </ng-container>
    }
      <tr mat-header-row *matHeaderRowDef="displayedColumns()"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns()" [class.bg-secondary-subtle]="row.Disabled"></tr>
      <tr *matNoDataRow>
        <td class="no-data-cell p-3 fw-semibold" [attr.colspan]="displayedColumns().length">No record found.</td>
      </tr>
    </table>
    <mat-paginator [length]="table.pageLength()" [pageIndex]="table.pageIndex()" [pageSize]="table.pageSize()" [pageSizeOptions]="[25, 50, 100]" (page)="table.onPage($event)" showFirstLastButtons></mat-paginator>
  </div>
</div>